import { mutationTypes } from './types'
import initialState from './initial-state'
import Vue from 'vue'
import store from '@/store'

export default {
  [mutationTypes.RESET_STATE]: (state, dirty) => {
    const initState = initialState()
    Object.keys(initState).forEach(key => {
      state[key] = initState[key]
    })
  },
  [mutationTypes.GET_WORKSPACES_PENDING]: (state) => {
    state.errors = []
    state.isLoading = true
  },
  [mutationTypes.GET_WORKSPACES_FAILURE]: (state, errors) => {
    state.errors = errors
    state.workspacesList = []
    state.isLoading = false
  },
  [mutationTypes.GET_WORKSPACES_SUCCESS]: (state, workspaces) => {
    state.workspacesList = workspaces
    state.errors = []
    state.isLoading = false
  },
  [mutationTypes.GET_NEW_WORKSPACE_ID_PENDING]: (state) => {
    state.newWorkspaceId = 'loading'
    state.errors = []
  },
  [mutationTypes.GET_NEW_WORKSPACE_ID_FAILURE]: (state, errors) => {
    state.errors = errors
    state.newWorkspaceId = ''
  },
  [mutationTypes.GET_NEW_WORKSPACE_ID_SUCCESS]: (state, workspaceId) => {
    state.newWorkspaceId = workspaceId
    state.errors = []
  },
}
